import { escapeHtml } from './sanitize';

/**
 * Standardized global notification toast conformed to Shopify Polaris aesthetics.
 * Renders both an <s-toast> element and a styled visual fallback container.
 */
export function showToast(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'success') {
  // Clear any existing active global toasts to prevent stacking/clutter
  const existing = document.querySelectorAll('.opm-toast-global');
  existing.forEach(el => el.remove());

  // Append visually polished DOM fallback container styled via Polaris design system
  const fallback = document.createElement('div');
  fallback.className = `opm-toast-global opm-toast-${type}`;

  // Set inline styling for high-priority display
  fallback.style.position = 'fixed';
  fallback.style.bottom = '2rem';
  fallback.style.right = '2rem';
  fallback.style.zIndex = '99999';

  let bgColor = 'var(--p-color-bg-inverse, #1f2124)';
  let textColor = 'white';
  let iconType = 'circle-check-major';

  if (type === 'error') {
    bgColor = 'var(--p-color-bg-critical, #d72c0d)';
    iconType = 'alert-circle';
  } else if (type === 'warning') {
    bgColor = 'var(--p-color-bg-warning, #e0b510)';
    textColor = 'black';
    iconType = 'circle-alert-major';
  } else if (type === 'info') {
    bgColor = 'var(--p-color-bg-info, #008060)';
    iconType = 'info-minor';
  }
  else if (type === 'success') {
    bgColor = 'var(--p-color-bg-success, #067647)';
    iconType = 'circle-check-major';
  }

  fallback.style.background = bgColor;
  fallback.style.color = textColor;
  fallback.style.padding = '0.75rem 1rem';
  fallback.style.borderRadius = 'var(--p-border-radius-200, 8px)';
  fallback.style.boxShadow = 'var(--p-shadow-400, 0 16px 20px rgba(0,0,0,0.15))';
  fallback.style.display = 'flex';
  fallback.style.alignItems = 'center';
  fallback.style.gap = '0.5rem';
  fallback.style.fontSize = '0.875rem';
  fallback.style.fontWeight = '500';
  fallback.style.transition = 'all 0.3s ease';
  fallback.style.opacity = '0';
  fallback.style.transform = 'translateY(10px)';

  fallback.innerHTML = `
    <s-icon type="${iconType}" size="base" style="fill: currentColor;"></s-icon>
    <span>${escapeHtml(message)}</span>
  `;
  document.body.appendChild(fallback);

  // Trigger browser paint for entry transitions
  requestAnimationFrame(() => {
    fallback.style.opacity = '1';
    fallback.style.transform = 'translateY(0)';
  });

  // Automatically remove toast elements after timeout completes
  setTimeout(() => {
    fallback.style.opacity = '0';
    fallback.style.transform = 'translateY(10px)';
    setTimeout(() => fallback.remove(), 300);
  }, 4000);
}
